import { AvailabilityTypes } from '@/enums/productAvailabilityTypes'

export function isResourcesValid(event) {
    if (!event) return false;

    if (event.availabilityType !== AvailabilityTypes.LIMITED_BY_RESOURCES) return true;

    const resources = event.eventResources || [];
    if (resources.length === 0) return false;

    return !resources.some(res => {
        if (res == null) return false;

        const maxSeats = res.maxSeats || 0;
        const availability = res.availability || 0;

        return maxSeats > availability;
    });
}
export function isBlockedByResourceErrors(event, hasResourceErrors) {
    if (!event) return false;
    return !!(event.availabilityType === AvailabilityTypes.LIMITED_BY_RESOURCES && !!hasResourceErrors);
}

export default {
    isResourcesValid,
    isBlockedByResourceErrors
}




// WEBPACK FOOTER //
// ./src/utils/resourcesValidation.js